
export const SET_CURRENT_HOSPITAL = "setCurrentHospital";

export const HOSPITAL_SIGN_IN_SUCCESS = "hospitalSignInSuccess";
export const HOSPITAL_SIGN_IN_FAILURE = "hospitalSignInFailure";